import { Link } from 'react-router-dom';
import { BadgeCheck } from 'lucide-react';
import { Card, CardContent, CardHeader } from '../../ui/Card';
import { planSummary } from '../../../billing/pricingV2';

export default function PlanCard({ plan }) {
  const { name, features } = planSummary(plan);

  return (
    <Card variant="elevated" data-testid="plan-card">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-3 squircle-sm bg-amber-100 dark:bg-amber-900/30">
            <BadgeCheck className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
          <div>
            <h3 data-testid="plan-name" className="text-heading font-semibold text-gray-900 dark:text-gray-100">
              {name}
            </h3>
            <Link
              to="/pricing"
              data-testid="plan-see-plans"
              className="text-body-sm font-medium text-amber-700 dark:text-amber-400 underline"
            >
              {plan.slug ? 'Change plan' : 'Choose a plan'}
            </Link>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <ul className="space-y-1.5 text-body-sm text-gray-600 dark:text-gray-400">
          {features.map(feature => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
